export const handleClose = (data, SetField, setErrors, setValid = () => {}) => {
  SetField(data);
  setErrors({});
  setValid(false); // Won't fail even if `setValid` isn't provided
};
